import { Dropdown, Menu } from "antd";
import { FC } from "react";
import { IIconButtonProps } from "../buttons/iconButtons/BaseIconButton";
import styles from './ButtonDropDown.module.scss'

export interface IItem {
    label: string;
    clueText?: string;
    onClick: () => void;
    disabled?: boolean;
    getView?: () => void,
}

interface IButtonDropDownProps {
    items: IItem[];
    button?: FC<IIconButtonProps>;
    disabledDropdown?: boolean;
    placement?: "topLeft" | "topCenter" | "topRight" | "bottomLeft" | "bottomCenter" | "bottomRight" | "top" | "bottom";
    onClick?: () => void,
}

export const ButtonDropDown: FC<IButtonDropDownProps> = (props) => {
    const itemsMenu = props.items?.map((x, i) => {
        return {
            label: <p style={{marginBottom: 0}} onClick={() => !x.disabled && x.onClick()}>{x.label}</p>,
            disabled: x.disabled,
            key: i,
        };
    });

    const menu = <Menu className={styles.menuCustom} items={itemsMenu} />;

    return (
        <Dropdown
            className={styles.dropdownCustom}
            disabled={props.disabledDropdown}
            placement={props.placement}
            getPopupContainer={() => document.body}
            overlayStyle={{
                width: 'auto',
                minWidth: 100,
                whiteSpace: 'nowrap',
                border: '1px solid #ced4da',
                borderRadius: 2
              }}
            overlay={menu}
            trigger={["click"]}
        >
            {props.button ? <props.button sizeVariant="normal" onClick={() => props.onClick?.()} /> : props.children}
        </Dropdown>
    );
};
